import { Box, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

import { LoyaltyLoader } from '../loyalty-loader';

export const StyledLoyaltyLoader = LoyaltyLoader;

export const OffersCooldownContainer = Box.withConfig({
  backgroundColor: primitive.bk.$warningLight,
  paddingY: '$2',
});

export const CooldownMessageContainer = Box.withConfig({
  flexDirection: 'column',
});

export const OffersCooldownTitle = Text.withConfig({
  variant: 'headerFour',
  fontSize: 'xs',
  marginBottom: '$0',
});

export const OffersCooldownMessage = Text.withConfig({
  variant: 'copyTwo',
  fontSize: 'xs',
});
